export const headersCotacao = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 6, key: 'statusCotacao' },
  { text: 'Nº REQ', width: 5, key: 'numeracaoReq' },
  { text: 'Produto Farmacêutico', width: 20, key: 'produtoDAF' },
  { text: 'Valor Unit. US$', width: 7, key: 'valorUnitario' },
  { text: 'Câmbio R$/US$', width: 8, key: 'cotacaoDolar' },
  { text: 'Qtd Cotada', width: 7, key: 'qtdCotada' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const valoresExibidosCotacao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Cotação
  statusCotacao: 'Status da Cotação',
  numeracaoReq: 'Nº da REQ',
  produtoDAF: 'Produto Farmacêutico',
  valorUnitario: 'Valor Unitário US$',
  cotacaoDolar: 'Cotação do Dólar',
  dataCotacao: 'Data da Cotação',
  qtdCotada: 'Qtd Cotada',
  valorTotal: 'Valor Total R$',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorCotacao: '',
};

export const fieldObjectCotacao = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
